import { HardHat, Stethoscope } from "lucide-react";

const OPTIONS = [
  { value: "general", label: "Umum (MCU standar)", desc: "Laporan radiologi MCU rutin", Icon: Stethoscope },
  { value: "ilo", label: "Standar ILO", desc: "Pneumokoniosis — pekerja tambang / industri", Icon: HardHat },
];

export default function ReportStandardSelect({ value, onChange, testId = "report-standard-select" }) {
  return (
    <div>
      <label className="text-[10px] uppercase tracking-[0.14em] text-zinc-500 font-semibold block mb-1.5">
        Standar Pelaporan
      </label>
      <div className="grid grid-cols-2 gap-1.5" data-testid={testId}>
        {OPTIONS.map(({ value: v, label, desc, Icon }) => {
          const active = value === v;
          return (
            <button
              key={v}
              type="button"
              data-testid={`${testId}-${v}`}
              onClick={() => onChange(v)}
              className={`rounded-lg border px-3 py-2 text-left transition-colors ${
                active
                  ? v === "ilo"
                    ? "bg-teal-600/20 border-teal-500/50 text-teal-100"
                    : "bg-indigo-600/20 border-indigo-500/50 text-indigo-100"
                  : "bg-zinc-950 border-zinc-800 text-zinc-400 hover:border-zinc-600"
              }`}
            >
              <div className="flex items-center gap-1.5 text-xs font-medium">
                <Icon className="w-3.5 h-3.5" /> {label}
              </div>
              <div className="text-[10px] opacity-70 mt-0.5 leading-tight">{desc}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
